import React, { useContext } from 'react';
import type { PropsWithChildren } from 'react';

type TDropDownContextValue = {
    leftShift: number;
};

const DropDownContext = React.createContext<TDropDownContextValue>({ leftShift: 0 });
export const DropDownContextProvider = ({
    children,
    leftShift = 0,
}: PropsWithChildren<Partial<TDropDownContextValue>>) => {
    return (
        <DropDownContext.Provider value={{ leftShift: leftShift }}>
            {children}
        </DropDownContext.Provider>
    );
};
export const useDropDownContext = () => useContext(DropDownContext);
